// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #8A8A8A;
  text-decoration-color: #FFFFFF !important;
  min-height: 100vh;
  display: flex;
    /*
  flex-direction: column;
  align-items: center;
  justify-content: center;*/
  font-size: calc(10px + 2vmin);
  color: white;
  height: 4.5rem;
  min-height: 40px;
}

.App-footer-slin {
  background-color: #8A8A8A;
  text-decoration-color: #FFFFFF !important;
  color: white;
  text-align: center;
  position:fixed;bottom:0;left:0;right:0;height:30px; 
  width: 89%;
}

.App-link {
  color: #61dafb;
}

.MuiButton-colorPrimary {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}


@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.App-titulo-center {
  margin: 0;
  position: absolute;
  top: 7%;
  transform: translateY(-50%);
}

.App-align-left {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/componentes/common/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;IACX;;;2BAGuB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,YAAY;EACZ,kBAAkB;EAClB,cAAc,CAAC,QAAQ,CAAC,MAAM,CAAC,OAAO,CAAC,WAAW;EAClD,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,OAAO;EAEP,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #8A8A8A;\n  text-decoration-color: #FFFFFF !important;\n  min-height: 100vh;\n  display: flex;\n    /*\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;*/\n  font-size: calc(10px + 2vmin);\n  color: white;\n  height: 4.5rem;\n  min-height: 40px;\n}\n\n.App-footer-slin {\n  background-color: #8A8A8A;\n  text-decoration-color: #FFFFFF !important;\n  color: white;\n  text-align: center;\n  position:fixed;bottom:0;left:0;right:0;height:30px; \n  width: 89%;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.MuiButton-colorPrimary {\n  color: #fff;\n  background-color: #286090;\n  border-color: #204d74;\n}\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.App-titulo-center {\n  margin: 0;\n  position: absolute;\n  top: 7%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.App-align-left {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
